export default __webpack_public_path__ + "static/media/single-rope-border-left.5e49ec8a.svg";